const Utils = {
  apiUriBase: 'http://91.239.81.86:62000/api/v1/cross',
  imgUriBase: 'http://91.239.81.86:62000',
};

export default Utils;
